module.exports = __webpack_public_path__ + "static/media/2_4.da4408b5.png";